import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const permission = route.data['permission'] as string | undefined;
    if (!permission?.trim()) {
      return true;
    }
    if (this.authService.hasPermission(permission)) {
      return true;
    }
    return this.router.createUrlTree(['/access-denied']);
  }
}
